export default {
	smoothstep(x, min, max) {
		if (x <= min) return 0;
		if (x >= max) return 1;

		x = (x - min) / (max - min);

		return x * x * (3 - 2 * x);
	},

	smootherstep(x, min, max) {
		if (x <= min) return 0;
		if (x >= max) return 1;

		x = (x - min) / (max - min);

		return x * x * x * (x * (x * 6 - 15) + 10);
	},

	clamp(x, min, max) {
		return Math.max(min, Math.min(max, x));
	},

	mapLinear(x, a1, a2, b1, b2) {
		return b1 + ((x - a1) * (b2 - b1)) / (a2 - a1);
	},

	hexToRgb(hex) {
		// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
		var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
		hex = hex.replace(shorthandRegex, function(m, r, g, b) {
			return r + r + g + g + b + b;
		});

		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result
			? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16),
			  }
			: null;
	},

	rgba({ r, g, b, a }) {
		return `rgba(${r},${g},${b},${a})`;
	},
};



// WEBPACK FOOTER //
// ./src/utils.js